<template>
  <v-flex sm12 md12 lg12>
    <v-card>
      <v-card-title>Authorised Representative Signature</v-card-title>
      <v-img :src="signatureImg" id="sign_prev" v-if="signature"></v-img>
      <v-card-text>
        <v-layout row wrap align-center v-show="!inactive">
          <VueSignaturePad
            saveType="image/png"
            ref="signaturePad"
            :customStyle="customStyle"
            id="signature"
          />
        </v-layout>
        <v-flex sm4 md4 lg4>
          <label class="subheading">
            <v-text-field
              v-for="(prop,propIndex) in additionalFields"
              :key="propIndex"
              :label="prop.label"
              :name="prop.name"
              :disabled="inactive"
              v-model="prop.model"
              :error-messages="errors.collect(prop.name)"
              :data-vv-as="prop.label"
              v-validate="'required'"
            />
          </label>
        </v-flex>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn :disabled="inactive" @click="undo(true)" color="primary">Undo</v-btn>
      </v-card-actions>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  name: "UtilitySignaturePad",
  inject: {
    $validator: "$validator"
  },
  props: {
    signature: String,
    signatureImg: String,
    additionalFields: Array,
    inactive: Boolean
  },
  data() {
    return {
      customStyle: {
        "background-color": "#1aa25714",
        "background-image": `url(${require("@/assets/images/SignHereWatermark.png")}`,
        "background-repeat": "no-repeat",
        "background-size": "contain",
        height: "320px",
        width: "100%",
        "background-position": "center"
      }
    };
  }
};
</script>

<style>
</style>
